'use client';
import { styled } from '@mui/material/styles';
export const SelectDropdownHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: 0,
    borderBottom: `0.50px ${theme.tokens.FuelColorBorderBase} solid`,
    backgroundColor: theme.tokens.FuelColorGray50,
    display: 'grid',
    gap: theme.tokens.FuelSpacing2,
    zIndex: 3,
    padding: `${theme.tokens.FuelSpacing2} ${theme.tokens.FuelSpacing4}`
}));
